import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class SearchableFilterResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/searchable_filter'

  pk() {
    return 'searchable_filter';
  }
}